export default {
	namespaced: true,
	state: {
		collecteCollectibles: [],
		client: {},
	},
	mutations: {
		resetCollecte(state) {
			state.collecteCollectibles = [];
		},
		setClient(state, clientData) {
			state.client = clientData;
		},
	},
};
